<atl-default-dropdown>
  <div [class.pointer-events-none]="disabled">
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</atl-default-dropdown>
